// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  * react-form-wizard-component
  * Creator:Parsa Jiravand
  * A react form wizard component with validation and progress bar with no external depenendcies which simplifies tab wizard management.
  * v0.1.7
  * MIT License
  */

.react-form-wizard .wizard-btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.428571429;
  border-radius: 4px;
  color: #fff;
}
.react-form-wizard .wizard-btn.disabled,
.react-form-wizard .wizard-btn[disabled],
fieldset[disabled] .react-form-wizard .wizard-btn {
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  box-shadow: none;
}
.react-form-wizard {
  margin-bottom: 1.5rem;
}
.react-form-wizard * {
  box-sizing: border-box;
}
.react-form-wizard a {
  text-decoration: none;
}
.react-form-wizard .wizard-nav {
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
}
.react-form-wizard .wizard-nav > li {
  position: relative;
  display: block;
}
.react-form-wizard .wizard-nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}
.react-form-wizard .wizard-nav > li > a:hover,
.react-form-wizard .wizard-nav > li > a:focus {
  text-decoration: none;
  background-color: #eee;
}
.react-form-wizard .wizard-nav > li.disabled > a {
  color: #777;
}
.react-form-wizard .wizard-nav > li.disabled > a:hover,
.react-form-wizard .wizard-nav > li.disabled > a:focus {
  color: #777;
  text-decoration: none;
  background-color: transparent;
  cursor: not-allowed;
}
.react-form-wizard .wizard-progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #337ab7;
  box-shadow: inset 0 -1px #00000026;
  transition: width 0.6s ease;
}
.react-form-wizard .wizard-btn,
.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn {
  box-sizing: border-box;
  border-width: 2px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 12px;
  min-width: 140px;
}
.react-form-wizard .wizard-btn:hover,
.react-form-wizard .wizard-btn:focus,
.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn:hover,
.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn:focus {
  outline: 0 !important;
}
.react-form-wizard .wizard-nav-pills {
  margin-top: 0;
  position: relative;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
}
.react-form-wizard .wizard-nav-pills li,
.react-form-wizard .wizard-nav-pills a {
  flex: 1 1;
  align-items: center;
  flex-wrap: wrap;
  flex-grow: 1;
}
.react-form-wizard .wizard-nav-pills a {
  display: flex;
}
.react-form-wizard .wizard-nav-pills > li > a {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0 auto;
  color: #0003;
  position: relative;
  top: 3px;
}
.react-form-wizard .wizard-nav-pills > li > a:hover,
.react-form-wizard .wizard-nav-pills > li > a:focus {
  background-color: transparent;
  color: #0003;
  outline: 0 !important;
}
.react-form-wizard .wizard-nav-pills > li > a.disabled {
  pointer-events: none;
  cursor: default;
}
.react-form-wizard .wizard-nav-pills > li.active > a,
.react-form-wizard .wizard-nav-pills > li.active > a:hover,
.react-form-wizard .wizard-nav-pills > li.active > a:focus {
  background-color: transparent;
  transition: font-size 0.2s linear;
}
.react-form-wizard .wizard-nav-pills > li.active > a .wizard-icon,
.react-form-wizard .wizard-nav-pills > li.active > a:hover .wizard-icon,
.react-form-wizard .wizard-nav-pills > li.active > a:focus .wizard-icon {
  color: #fff;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s linear;
}
.react-form-wizard {
  padding-bottom: 20px;
}
.react-form-wizard .is_error {
  border-color: #c84513 !important;
}
.react-form-wizard .is_error .icon-container {
  background: #c84513 !important;
}
.react-form-wizard.xs .wizard-icon-circle {
  width: 40px;
  height: 40px;
  font-size: 16px;
}
.react-form-wizard.xs .wizard-icon-circle.tab_shape {
  height: 25px;
}
.react-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 16px;
}
.react-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 25px;
  height: 4px;
}
.react-form-wizard.sm .wizard-icon-circle {
  width: 50px;
  height: 50px;
  font-size: 20px;
}
.react-form-wizard.sm .wizard-icon-circle.tab_shape {
  height: 30px;
}
.react-form-wizard.sm .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 20px;
}
.react-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 30px;
  height: 4px;
}
.react-form-wizard.md .wizard-icon-circle {
  width: 70px;
  height: 70px;
  font-size: 24px;
}
.react-form-wizard.md .wizard-icon-circle.tab_shape {
  height: 40px;
}
.react-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 24px;
}
.react-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 40px;
  height: 4px;
}
.react-form-wizard.lg .wizard-icon-circle {
  width: 90px;
  height: 90px;
  font-size: 28px;
}
.react-form-wizard.lg .wizard-icon-circle.tab_shape {
  height: 50px;
}
.react-form-wizard.lg .wizard-nav-pills > li.active > a .wizard-icon {
  font-size: 28px;
}
.react-form-wizard.lg .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 50px;
  height: 4px;
}
.react-form-wizard .wizard-icon-circle {
  font-size: 18px;
  border: 3px solid #f3f2ee;
  border-radius: 50%;
  font-weight: 600;
  width: 70px;
  height: 70px;
  background-color: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
}
.react-form-wizard .wizard-icon-circle.square_shape {
  border-radius: 0;
}
.react-form-wizard .wizard-icon-circle.tab_shape {
  width: 100%;
  min-width: 100px;
  height: 40px;
  border: none;
  background-color: #f3f2ee;
  border-radius: 0;
}
.react-form-wizard .wizard-icon-circle .wizard-icon-container {
  display: flex;
  justify-content: center;
  flex: 1 1;
  border-radius: 50%;
  margin: -3px;
}
.react-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {
  border-radius: 0;
}
.react-form-wizard .wizard-icon-circle .wizard-icon-container.tab_shape {
  border-radius: 0;
  margin: 0;
}
.react-form-wizard .wizard-icon-circle .wizard-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.react-form-wizard .wizard-tab-content {
  min-height: 100px;
  padding: 30px 20px 10px;
  text-align: center;
}
.react-form-wizard .wizard-header {
  padding: 15px;
  position: relative;
  border-radius: 3px 3px 0 0;
  text-align: center;
}
.react-form-wizard .wizard-title {
  color: #252422;
  font-weight: 300;
  margin: 0;
  text-align: center;
}
.react-form-wizard .category {
  font-size: 14px;
  font-weight: 400;
  color: #9a9a9a;
  margin-bottom: 0;
  text-align: center;
}
.react-form-wizard .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 40px;
  height: 4px;
}
.react-form-wizard
  .wizard-navigation
  .wizard-progress-with-circle
  .wizard-progress-bar {
  box-shadow: none;
  transition: width 0.3s ease;
}
.react-form-wizard .clearfix:after {
  content: "";
  clear: both;
  display: table;
}
.react-form-wizard .wizard-card-footer {
  padding: 0 20px;
}
.react-form-wizard .wizard-card-footer .wizard-footer-left {
  float: left;
}
.react-form-wizard .wizard-card-footer .wizard-footer-right {
  float: right;
}
@media screen and (max-width: 350px) {
  .react-form-wizard .wizard-card-footer {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .react-form-wizard .wizard-card-footer .wizard-footer-left,
  .react-form-wizard .wizard-card-footer .wizard-footer-right {
    float: none;
    flex: 1 1;
    display: flex;
    justify-content: center;
  }
  .react-form-wizard .wizard-card-footer .wizard-footer-right button {
    margin-top: 10px;
  }
}
.react-form-wizard.vertical .wizard-card-footer {
  display: block;
}
.react-form-wizard.vertical .wizard-nav-pills {
  flex-direction: column;
}
.react-form-wizard.vertical .wizard-navigation {
  display: flex;
  flex-direction: row;
}
.react-form-wizard.vertical .wizard-card-footer {
  padding-top: 30px;
}

.react-form-wizard .wizard-icon-circle {
  width: 25px;
  height: 25px;
}
li.active .wizard-icon-container {
  background-color: #004c6c;
}

li.active .stepTitle {
  color: #004c6c;
}
li.active .ti-user {
  color: #ffffff;
}

.react-form-wizard .wizard-navigation .wizard-progress-with-circle {
  position: relative;
  top: 16px;
  height: 4px;
  background: #f3f2ee;
}

.react-form-wizard {
  padding-bottom: 0;
}

li.active .wizard-icon-container {
  background-color: #53b8e2;
}
li.active.current .wizard-icon-container {
  background-color: #004c6c;
}
`, "",{"version":3,"sources":["webpack://./src/components/wizard-style.css"],"names":[],"mappings":"AAAA;;;;;;GAMG;;AAEH;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;AACb;AACA;;;EAGE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EAEzB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EAEzB,kCAAkC;EAGlC,2BAA2B;AAC7B;AACA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,SAAO;EACP,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;;;EAGE,6BAA6B;EAK7B,iCAAiC;AACnC;AACA;;;EAGE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAKvB,2BAA2B;AAC7B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAO;EACP,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;;;;EAIE,gBAAgB;EAGhB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;EACxB;EACA;;IAEE,WAAW;IACX,SAAO;IACP,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["/*\n  * react-form-wizard-component\n  * Creator:Parsa Jiravand\n  * A react form wizard component with validation and progress bar with no external depenendcies which simplifies tab wizard management.\n  * v0.1.7\n  * MIT License\n  */\n\n.react-form-wizard .wizard-btn {\n  display: inline-block;\n  margin-bottom: 0;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  padding: 6px 12px;\n  font-size: 14px;\n  line-height: 1.428571429;\n  border-radius: 4px;\n  color: #fff;\n}\n.react-form-wizard .wizard-btn.disabled,\n.react-form-wizard .wizard-btn[disabled],\nfieldset[disabled] .react-form-wizard .wizard-btn {\n  cursor: not-allowed;\n  opacity: 0.65;\n  filter: alpha(opacity=65);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.react-form-wizard {\n  margin-bottom: 1.5rem;\n}\n.react-form-wizard * {\n  box-sizing: border-box;\n}\n.react-form-wizard a {\n  text-decoration: none;\n}\n.react-form-wizard .wizard-nav {\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n.react-form-wizard .wizard-nav > li {\n  position: relative;\n  display: block;\n}\n.react-form-wizard .wizard-nav > li > a {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n}\n.react-form-wizard .wizard-nav > li > a:hover,\n.react-form-wizard .wizard-nav > li > a:focus {\n  text-decoration: none;\n  background-color: #eee;\n}\n.react-form-wizard .wizard-nav > li.disabled > a {\n  color: #777;\n}\n.react-form-wizard .wizard-nav > li.disabled > a:hover,\n.react-form-wizard .wizard-nav > li.disabled > a:focus {\n  color: #777;\n  text-decoration: none;\n  background-color: transparent;\n  cursor: not-allowed;\n}\n.react-form-wizard .wizard-progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: 12px;\n  line-height: 20px;\n  color: #fff;\n  text-align: center;\n  background-color: #337ab7;\n  -webkit-box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);\n  box-shadow: inset 0 -1px #00000026;\n  -webkit-transition: width 0.6s ease;\n  -o-transition: width 0.6s ease;\n  transition: width 0.6s ease;\n}\n.react-form-wizard .wizard-btn,\n.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn {\n  box-sizing: border-box;\n  border-width: 2px;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 12px;\n  min-width: 140px;\n}\n.react-form-wizard .wizard-btn:hover,\n.react-form-wizard .wizard-btn:focus,\n.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn:hover,\n.react-form-wizard .navbar .navbar-nav > li > a.wizard-btn:focus {\n  outline: 0 !important;\n}\n.react-form-wizard .wizard-nav-pills {\n  margin-top: 0;\n  position: relative;\n  text-align: center;\n  display: flex;\n  flex-wrap: wrap;\n}\n.react-form-wizard .wizard-nav-pills li,\n.react-form-wizard .wizard-nav-pills a {\n  flex: 1;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-grow: 1;\n}\n.react-form-wizard .wizard-nav-pills a {\n  display: flex;\n}\n.react-form-wizard .wizard-nav-pills > li > a {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  margin: 0 auto;\n  color: #0003;\n  position: relative;\n  top: 3px;\n}\n.react-form-wizard .wizard-nav-pills > li > a:hover,\n.react-form-wizard .wizard-nav-pills > li > a:focus {\n  background-color: transparent;\n  color: #0003;\n  outline: 0 !important;\n}\n.react-form-wizard .wizard-nav-pills > li > a.disabled {\n  pointer-events: none;\n  cursor: default;\n}\n.react-form-wizard .wizard-nav-pills > li.active > a,\n.react-form-wizard .wizard-nav-pills > li.active > a:hover,\n.react-form-wizard .wizard-nav-pills > li.active > a:focus {\n  background-color: transparent;\n  -webkit-transition: font-size 0.2s linear;\n  -moz-transition: font-size 0.2s linear;\n  -o-transition: font-size 0.2s linear;\n  -ms-transition: font-size 0.2s linear;\n  transition: font-size 0.2s linear;\n}\n.react-form-wizard .wizard-nav-pills > li.active > a .wizard-icon,\n.react-form-wizard .wizard-nav-pills > li.active > a:hover .wizard-icon,\n.react-form-wizard .wizard-nav-pills > li.active > a:focus .wizard-icon {\n  color: #fff;\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  -webkit-transition: all 0.2s linear;\n  -moz-transition: all 0.2s linear;\n  -o-transition: all 0.2s linear;\n  -ms-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.react-form-wizard {\n  padding-bottom: 20px;\n}\n.react-form-wizard .is_error {\n  border-color: #c84513 !important;\n}\n.react-form-wizard .is_error .icon-container {\n  background: #c84513 !important;\n}\n.react-form-wizard.xs .wizard-icon-circle {\n  width: 40px;\n  height: 40px;\n  font-size: 16px;\n}\n.react-form-wizard.xs .wizard-icon-circle.tab_shape {\n  height: 25px;\n}\n.react-form-wizard.xs .wizard-nav-pills > li.active > a .wizard-icon {\n  font-size: 16px;\n}\n.react-form-wizard.xs .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 25px;\n  height: 4px;\n}\n.react-form-wizard.sm .wizard-icon-circle {\n  width: 50px;\n  height: 50px;\n  font-size: 20px;\n}\n.react-form-wizard.sm .wizard-icon-circle.tab_shape {\n  height: 30px;\n}\n.react-form-wizard.sm .wizard-nav-pills > li.active > a .wizard-icon {\n  font-size: 20px;\n}\n.react-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 30px;\n  height: 4px;\n}\n.react-form-wizard.md .wizard-icon-circle {\n  width: 70px;\n  height: 70px;\n  font-size: 24px;\n}\n.react-form-wizard.md .wizard-icon-circle.tab_shape {\n  height: 40px;\n}\n.react-form-wizard.md .wizard-nav-pills > li.active > a .wizard-icon {\n  font-size: 24px;\n}\n.react-form-wizard.md .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 40px;\n  height: 4px;\n}\n.react-form-wizard.lg .wizard-icon-circle {\n  width: 90px;\n  height: 90px;\n  font-size: 28px;\n}\n.react-form-wizard.lg .wizard-icon-circle.tab_shape {\n  height: 50px;\n}\n.react-form-wizard.lg .wizard-nav-pills > li.active > a .wizard-icon {\n  font-size: 28px;\n}\n.react-form-wizard.lg .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 50px;\n  height: 4px;\n}\n.react-form-wizard .wizard-icon-circle {\n  font-size: 18px;\n  border: 3px solid #f3f2ee;\n  border-radius: 50%;\n  font-weight: 600;\n  width: 70px;\n  height: 70px;\n  background-color: #fff;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n}\n.react-form-wizard .wizard-icon-circle.square_shape {\n  border-radius: 0;\n}\n.react-form-wizard .wizard-icon-circle.tab_shape {\n  width: 100%;\n  min-width: 100px;\n  height: 40px;\n  border: none;\n  background-color: #f3f2ee;\n  border-radius: 0;\n}\n.react-form-wizard .wizard-icon-circle .wizard-icon-container {\n  display: flex;\n  justify-content: center;\n  flex: 1;\n  border-radius: 50%;\n  margin: -3px;\n}\n.react-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape {\n  border-radius: 0;\n}\n.react-form-wizard .wizard-icon-circle .wizard-icon-container.tab_shape {\n  border-radius: 0;\n  margin: 0;\n}\n.react-form-wizard .wizard-icon-circle .wizard-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.react-form-wizard .wizard-tab-content {\n  min-height: 100px;\n  padding: 30px 20px 10px;\n  text-align: center;\n}\n.react-form-wizard .wizard-header {\n  padding: 15px;\n  position: relative;\n  border-radius: 3px 3px 0 0;\n  text-align: center;\n}\n.react-form-wizard .wizard-title {\n  color: #252422;\n  font-weight: 300;\n  margin: 0;\n  text-align: center;\n}\n.react-form-wizard .category {\n  font-size: 14px;\n  font-weight: 400;\n  color: #9a9a9a;\n  margin-bottom: 0;\n  text-align: center;\n}\n.react-form-wizard .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 40px;\n  height: 4px;\n}\n.react-form-wizard\n  .wizard-navigation\n  .wizard-progress-with-circle\n  .wizard-progress-bar {\n  box-shadow: none;\n  -webkit-transition: width 0.3s ease;\n  -o-transition: width 0.3s ease;\n  transition: width 0.3s ease;\n}\n.react-form-wizard .clearfix:after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n.react-form-wizard .wizard-card-footer {\n  padding: 0 20px;\n}\n.react-form-wizard .wizard-card-footer .wizard-footer-left {\n  float: left;\n}\n.react-form-wizard .wizard-card-footer .wizard-footer-right {\n  float: right;\n}\n@media screen and (max-width: 350px) {\n  .react-form-wizard .wizard-card-footer {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n  }\n  .react-form-wizard .wizard-card-footer .wizard-footer-left,\n  .react-form-wizard .wizard-card-footer .wizard-footer-right {\n    float: none;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n  }\n  .react-form-wizard .wizard-card-footer .wizard-footer-right button {\n    margin-top: 10px;\n  }\n}\n.react-form-wizard.vertical .wizard-card-footer {\n  display: block;\n}\n.react-form-wizard.vertical .wizard-nav-pills {\n  flex-direction: column;\n}\n.react-form-wizard.vertical .wizard-navigation {\n  display: flex;\n  flex-direction: row;\n}\n.react-form-wizard.vertical .wizard-card-footer {\n  padding-top: 30px;\n}\n\n.react-form-wizard .wizard-icon-circle {\n  width: 25px;\n  height: 25px;\n}\nli.active .wizard-icon-container {\n  background-color: #004c6c;\n}\n\nli.active .stepTitle {\n  color: #004c6c;\n}\nli.active .ti-user {\n  color: #ffffff;\n}\n\n.react-form-wizard .wizard-navigation .wizard-progress-with-circle {\n  position: relative;\n  top: 16px;\n  height: 4px;\n  background: #f3f2ee;\n}\n\n.react-form-wizard {\n  padding-bottom: 0;\n}\n\nli.active .wizard-icon-container {\n  background-color: #53b8e2;\n}\nli.active.current .wizard-icon-container {\n  background-color: #004c6c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
